var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { DropdownItem } from '../../../../../shared/dropdown-item';
import { LineStyleType } from '../../../../view-data/shared/line/general/line-style-type';
var LineStyleTypeService = /** @class */ (function () {
    function LineStyleTypeService(svgService) {
        this.svgService = svgService;
        this.lineStyleTypes = [];
    }
    LineStyleTypeService.prototype.getAll = function () {
        if (!this.lineStyleTypes.length) {
            this.lineStyleTypes.push(new DropdownItem(LineStyleType.Solid, this.getLineStyleTypeSVG(LineStyleType.Solid)));
            this.lineStyleTypes.push(new DropdownItem(LineStyleType.Dash, this.getLineStyleTypeSVG(LineStyleType.Dash)));
            this.lineStyleTypes.push(new DropdownItem(LineStyleType.Dot, this.getLineStyleTypeSVG(LineStyleType.Dot)));
            this.lineStyleTypes.push(new DropdownItem(LineStyleType.DashDot, this.getLineStyleTypeSVG(LineStyleType.DashDot)));
            this.lineStyleTypes.push(new DropdownItem(LineStyleType.DashDotDot, this.getLineStyleTypeSVG(LineStyleType.DashDotDot)));
        }
        return this.lineStyleTypes;
    };
    LineStyleTypeService.prototype.getLineStyleTypeSVG = function (type) {
        var svg = this.svgService.getSVGSVGElement('100%', '18');
        if (type === LineStyleType.Solid) {
            var line = this.svgService.getSVGLineElement('5', '11', '210', '11', '#333333', '1');
            svg.appendChild(line);
        }
        else {
            var g = this.svgService.getSVGGElement('#333333', '1', 'none');
            var path = this.svgService.getSVGPathElement('M5 11 l208 0');
            path.setAttributeNS(null, 'stroke-dasharray', this.getStrokeDasharray(type));
            g.appendChild(path);
            svg.appendChild(g);
        }
        return svg.outerHTML;
    };
    LineStyleTypeService.prototype.getStrokeDasharray = function (type) {
        if (type === LineStyleType.Dash) {
            return '10,3';
        }
        if (type === LineStyleType.Dot) {
            return '5,3';
        }
        if (type === LineStyleType.DashDot) {
            return '15,5,5,5';
        }
        if (type === LineStyleType.DashDotDot) {
            return '15,5,5,5,5,5';
        }
    };
    LineStyleTypeService = __decorate([
        Injectable()
    ], LineStyleTypeService);
    return LineStyleTypeService;
}());
export { LineStyleTypeService };
